import React, { Fragment, useContext, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import { ServiciosProvider } from "./context/ServiciosContext";
import { ConfiguracionProvider } from "./context/ConfiguracionContext";
import RutaPrivada from "./components/rutas/RutaPrivada";
import "@fortawesome/fontawesome-free/css/all.min.css";
//import Account from "./components/auth/Account";
import Login from "./components/auth/Login";
import Password from "./components/auth/Password";
//import Account from "./components/auth/Account";
import Reset from "./components/auth/Reset";
import Change from "./components/auth/Change";
//
import Menu from "./components/layout/Menu";
import ConfiguracionesEnvios from "./components/layout/ConfiguracionesEnvios";
import Accesos from "./components/layout/Accesos";
import Clientes from "./components/layout/Clientes";
import Rubros from "./components/layout/Rubros";
import Localidades from "./components/layout/Localidades";
import Planes from "./components/layout/Planes";
import Asesores from "./components/layout/Asesores";
import Cobradores from "./components/layout/Cobradores";
import Adicionales from "./components/layout/Adicionales";
import Empresas from "./components/layout/Empresas";
import MotivosBajas from "./components/layout/MotivosBajas";
import MotivosSuspendidos from "./components/layout/MotivosSuspendidos";
import FormasPagos from "./components/layout/FormasPagos";
import CondicionesPagos from "./components/layout/CondicionesPagos";
import TiposFacturas from "./components/layout/TiposFacturas";
import Facturacion from "./components/layout/Facturacion";
import Comprobantes from "./components/layout/Comprobantes";
import PuntosVentas from "./components/layout/PuntosVentas";
//import Ajustes from "./components/layout/Ajustes";
import Importaciones from "./components/layout/Importaciones";
import TiposRetenciones from "./components/layout/TiposRetenciones";
//import Rendiciones from "./components/layout/Rendiciones";
import RendicionesPendientes from "./components/layout/RendicionesPendientes";
import RendicionesPendientesItems from "./components/layout/RendicionesPendientesItems";
import RendicionesAplicadasEliminadas from "./components/layout/RendicionesAplicadasEliminadas";
import Bancos from "./components/layout/Bancos";
import Conversiones from "./components/layout/Conversiones";
import Monedas from "./components/layout/Monedas";
import Conceptos from "./components/layout/Conceptos";
import Cuentas from "./components/layout/Cuentas";
import Tarjetas from "./components/layout/Tarjetas";
//import RendicionesDiarias from "./components/layout/RendicionesDiarias";
import GenerarBarCode from "./components/layout/GenerarBarCode";
import MovimientosCajas from "./components/layout/MovimientosCajas";
import MovimientosCheques from "./components/layout/MovimientosCheques";
import MovimientosCompensaciones from "./components/layout/MovimientosCompensaciones";
import MovimientosTarjetas from "./components/layout/MovimientosTarjetas";
import MovimientosRetenciones from "./components/layout/MovimientosRetenciones";
import Proveedores from "./components/layout/Proveedores";
import FacturacionCompras from "./components/layout/FacturacionCompras";
import ComprobantesCompras from "./components/layout/ComprobantesCompras";
import OrdenPago from "./components/layout/OrdenPago";
import OrdenesPagos from "./components/layout/OrdenesPagos";
import MovimientosBancos from "./components/layout/MovimientosBancos";
import CierresPeriodos from "./components/layout/CierresPeriodos";
import ImportarComprobantes from "./components/layout/ImportarComprobantes";
import ListadosCartera from "./components/layout/listados/ListadosCartera";
import ListadosAltas from "./components/layout/listados/ListadosAltas";
import ListadosBajas from "./components/layout/listados/ListadosBajas";
import ListadosIvaVentas from "./components/layout/listados/ListadosIvaVentas";
import ListadosIvaCompras from "./components/layout/listados/ListadosIvaCompras";
import ListadosCobranzasPendientes from "./components/layout/listados/ListadosCobranzasPendientes";
import ListadosCobranzasRealizadas from "./components/layout/listados/ListadosCobranzasRealizadas";
import ListadosSuspendidos from "./components/layout/listados/ListadosSuspendidos";
import ListadosComprobantesVentas from "./components/layout/listados/ListadosComprobantesVentas";
import ListadosRetenciones from "./components/layout/listados/ListadosRetenciones";
import ListadosComprobantesCompras from "./components/layout/listados/ListadosComprobantesCompras";
import ListadosOrdenesPagos from "./components/layout/listados/ListadosOrdenesPagos";
import ListadosModulos from "./components/layout/listados/ListadosModulos";
import ProcesosFacturacion from "./components/layout/procesos/ProcesosFacturacion";
import ProcesosImpresion from "./components/layout/procesos/ProcesosImpresion";
import ProcesosBajasAutomaticas from "./components/layout/procesos/ProcesosBajasAutomaticas";
import ProcesosComprasYVentas from "./components/layout/procesos/ProcesosComprasYVentas";
import InformesProcesosFacturacion from "./components/layout/InformesProcesosFacturacion";
import ProcesosPercepcionesARBA from "./components/layout/procesos/ProcesosPercepcionesARBA";
import ProcesosPercepcionesAGIP from "./components/layout/procesos/ProcesosPercepcionesAGIP";
import ProcesosPagoFacilPagoMisCuentas from "./components/layout/procesos/ProcesosPagoFacilPagoMisCuentas";
import ProcesosDebitosAutomaticos from "./components/layout/procesos/ProcesosDebitosAutomaticos";
import RendicionesDebitosAutomaticos from "./components/layout/RendicionesDebitosAutomaticos";
import RendicionesMercadoPago from "./components/layout/RendicionesMercadoPago";
import RendicionesBancos from "./components/layout/RendicionesBancos";
import ListadosMensajes from "./components/layout/listados/ListadosMensajes";
import ListadosCobranzasPlanilla from "./components/layout/listados/ListadosCobranzasPlanilla";
import ListadoMovimientos from "./components/layout/listados/ListadoMovimientos";
import ListadoCajas from "./components/layout/listados/ListadoCajas";
import ListadoBancos from "./components/layout/listados/ListadoBancos";
import ListadoCheques from "./components/layout/listados/ListadoCheques";
import ListadoCompensaciones from "./components/layout/listados/ListadoCompensaciones";
import ListadoFacilidades from "./components/layout/listados/ListadoFacilidades";
import ListadoTarjetas from "./components/layout/listados/ListadoTarjetas";
import ListadoRetenciones from "./components/layout/listados/ListadoRetenciones";
import ListadosNoCobrables from "./components/layout/listados/ListadosNoCobrables";
import ListadosCuotasExtra from "./components/layout/listados/ListadosCuotasExtra";
import Qr from "./components/layout/Qr";
import QrCardio from "./components/layout/QrCardio";
import QrEmersur from "./components/layout/QrEmersur";
import EstadisticaCobradores from "./components/layout/listados/EstadisticaCobradores";
import TextosFacturas from "./components/layout/TextosFacturas";
import Presupuestos from "./components/layout/Presupuestos";
import PresupuestoCompleto from "./components/layout/PresupuestoCompleto";
import ListadosTopesServicios from "./components/layout/listados/ListadosTopesServicios";
import PresupuestosIngresos from "./components/layout/PresupuestosIngresos";
import Recibos from "./components/layout/Recibos";
import InformesProcesosPadrones from "./components/layout/InformesProcesosPadrones";
import WhatsAppCoexistence from "./components/layout/WhatsAppCoexistence";

//import Pacientes from "./components/layout/Pacientes";
/*
import Pedidos from "./components/layout/Pedidos";
import Comisiones from "./components/layout/Comisiones";
import ProductosEnvasados from "./components/layout/ProductosEnvasados";
import ProductosNaturales from "./components/layout/ProductosNaturales";
import ProductosElaborados from "./components/layout/ProductosElaborados";
import Movimientos from "./components/layout/Movimientos";
import ListadoSaldos from "./components/layout/listados/ListadoSaldos";
import ListadoStock from "./components/layout/listados/ListadoStock";
import ListadoComisiones from "./components/layout/listados/ListadoComisiones";
*/
function App() {
  return (
    <AlertProvider>
      <AuthProvider>
        <ServiciosProvider>
          <ConfiguracionProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/change/:token" element={<Change />} />
                <Route path="/reset" element={<Reset />} />
                <Route path="/" element={<Menu />} />
                <Route
                  path="/rendicionespendientesitems/:id"
                  element={
                    <RutaPrivada>
                      <RendicionesPendientesItems />
                    </RutaPrivada>
                  }
                />
                {/*
                <Route
                  path="/rendicionesdiarias"
                  element={<RendicionesDiarias />}
                />
                */}
                <Route
                  path="/password"
                  element={
                    <RutaPrivada>
                      <Password />
                    </RutaPrivada>
                  }
                />

                <Route
                  path="/movimientoscajas"
                  element={
                    <RutaPrivada>
                      <MovimientosCajas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/movimientoscheques/:origen"
                  element={
                    <RutaPrivada>
                      <MovimientosCheques />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/movimientosbancos"
                  element={
                    <RutaPrivada>
                      <MovimientosBancos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/movimientoscompensaciones"
                  element={
                    <RutaPrivada>
                      <MovimientosCompensaciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/movimientostarjetas"
                  element={
                    <RutaPrivada>
                      <MovimientosTarjetas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/movimientosretenciones"
                  element={
                    <RutaPrivada>
                      <MovimientosRetenciones />
                    </RutaPrivada>
                  }
                />
                {/*<Route path="/rendiciones" element={<Rendiciones />} />*/}
                <Route path="/generarbarcode" element={<GenerarBarCode />} />

                <Route
                  path="/accesos"
                  element={
                    <RutaPrivada>
                      <Accesos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/configuraciones"
                  element={
                    <RutaPrivada>
                      <ConfiguracionesEnvios />
                    </RutaPrivada>
                  }
                />

                <Route
                  path="/clientes"
                  element={
                    <RutaPrivada>
                      <Clientes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rubros"
                  element={
                    <RutaPrivada>
                      <Rubros />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/textosfacturas"
                  element={
                    <RutaPrivada>
                      <TextosFacturas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/localidades"
                  element={
                    <RutaPrivada>
                      <Localidades />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/planes"
                  element={
                    <RutaPrivada>
                      <Planes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/asesores"
                  element={
                    <RutaPrivada>
                      <Asesores />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/cobradores"
                  element={
                    <RutaPrivada>
                      <Cobradores />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/bancos"
                  element={
                    <RutaPrivada>
                      <Bancos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/conversiones"
                  element={
                    <RutaPrivada>
                      <Conversiones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/monedas"
                  element={
                    <RutaPrivada>
                      <Monedas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/cuentas"
                  element={
                    <RutaPrivada>
                      <Cuentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/tarjetas"
                  element={
                    <RutaPrivada>
                      <Tarjetas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/conceptos"
                  element={
                    <RutaPrivada>
                      <Conceptos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/adicionales"
                  element={
                    <RutaPrivada>
                      <Adicionales />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/empresas"
                  element={
                    <RutaPrivada>
                      <Empresas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/motivosbajas"
                  element={
                    <RutaPrivada>
                      <MotivosBajas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/formaspagos"
                  element={
                    <RutaPrivada>
                      <FormasPagos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/condicionespagos"
                  element={
                    <RutaPrivada>
                      <CondicionesPagos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/tiposfacturas"
                  element={
                    <RutaPrivada>
                      <TiposFacturas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/motivossuspendidos"
                  element={
                    <RutaPrivada>
                      <MotivosSuspendidos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/facturacion/:id/:titularId"
                  element={
                    <RutaPrivada>
                      <Facturacion />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/presupuesto/:sector"
                  element={
                    <RutaPrivada>
                      <Presupuestos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/presupuestounificado"
                  element={
                    <RutaPrivada>
                      <PresupuestoCompleto />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/presupuestosingresos/:sector"
                  element={
                    <RutaPrivada>
                      <PresupuestosIngresos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/comprobantes"
                  element={
                    <RutaPrivada>
                      <Comprobantes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/puntosventas"
                  element={
                    <RutaPrivada>
                      <PuntosVentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/uploadpercepciones"
                  element={
                    <RutaPrivada>
                      <Importaciones data={1} />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/uploadafiliados"
                  element={
                    <RutaPrivada>
                      <Importaciones data={3} />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesopercepciones"
                  element={
                    <RutaPrivada>
                      <Importaciones data={2} />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesoafiliados"
                  element={
                    <RutaPrivada>
                      <Importaciones data={4} />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/tiposretenciones"
                  element={
                    <RutaPrivada>
                      <TiposRetenciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rendicionespendientes/:origen"
                  element={
                    <RutaPrivada>
                      <RendicionesPendientes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rendicionesaplicadaseliminadas/:tipo"
                  element={
                    <RutaPrivada>
                      <RendicionesAplicadasEliminadas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/proveedores"
                  element={
                    <RutaPrivada>
                      <Proveedores />
                    </RutaPrivada>
                  }
                />

                <Route
                  path="/facturacioncompras/:id/:proveedorId"
                  element={
                    <RutaPrivada>
                      <FacturacionCompras />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/comprobantescompras"
                  element={
                    <RutaPrivada>
                      <ComprobantesCompras />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/ordenpago/:id/:proveedorId/:origen"
                  element={
                    <RutaPrivada>
                      <OrdenPago />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/ordenespagos/:origen"
                  element={
                    <RutaPrivada>
                      <OrdenesPagos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/cierresperiodos/:origen"
                  element={
                    <RutaPrivada>
                      <CierresPeriodos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/importarcomprobantes"
                  element={
                    <RutaPrivada>
                      <ImportarComprobantes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscartera"
                  element={
                    <RutaPrivada>
                      <ListadosCartera />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosaltas"
                  element={
                    <RutaPrivada>
                      <ListadosAltas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosbajas"
                  element={
                    <RutaPrivada>
                      <ListadosBajas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadossuspendidos"
                  element={
                    <RutaPrivada>
                      <ListadosSuspendidos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosmodulos"
                  element={
                    <RutaPrivada>
                      <ListadosModulos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosivaventas/:tipo"
                  element={
                    <RutaPrivada>
                      <ListadosIvaVentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosivacompras/:tipo"
                  element={
                    <RutaPrivada>
                      <ListadosIvaCompras />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscobranzaspendientes"
                  element={
                    <RutaPrivada>
                      <ListadosCobranzasPendientes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscobranzasrealizadas"
                  element={
                    <RutaPrivada>
                      <ListadosCobranzasRealizadas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscobranzasplanilla"
                  element={
                    <RutaPrivada>
                      <ListadosCobranzasPlanilla />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadomovimientos"
                  element={
                    <RutaPrivada>
                      <ListadoMovimientos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadocajas"
                  element={
                    <RutaPrivada>
                      <ListadoCajas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/recibos"
                  element={
                    <RutaPrivada>
                      <Recibos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadobancos"
                  element={
                    <RutaPrivada>
                      <ListadoBancos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadocompensaciones"
                  element={
                    <RutaPrivada>
                      <ListadoCompensaciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoretenciones"
                  element={
                    <RutaPrivada>
                      <ListadoRetenciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadofacilidades"
                  element={
                    <RutaPrivada>
                      <ListadoFacilidades />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadotarjetas"
                  element={
                    <RutaPrivada>
                      <ListadoTarjetas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoretenciones"
                  element={
                    <RutaPrivada>
                      <ListadoRetenciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosnocobrables"
                  element={
                    <RutaPrivada>
                      <ListadosNoCobrables />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscuotasextraordinarias"
                  element={
                    <RutaPrivada>
                      <ListadosCuotasExtra />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadocheques"
                  element={
                    <RutaPrivada>
                      <ListadoCheques />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscomprobantesventas"
                  element={
                    <RutaPrivada>
                      <ListadosComprobantesVentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadoscomprobantescompras"
                  element={
                    <RutaPrivada>
                      <ListadosComprobantesCompras />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosordenespagos"
                  element={
                    <RutaPrivada>
                      <ListadosOrdenesPagos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosretenciones"
                  element={
                    <RutaPrivada>
                      <ListadosRetenciones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesosfacturacion"
                  element={
                    <RutaPrivada>
                      <ProcesosFacturacion />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesosimpresion"
                  element={
                    <RutaPrivada>
                      <ProcesosImpresion />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesossbajasautomaticas"
                  element={
                    <RutaPrivada>
                      <ProcesosBajasAutomaticas />
                    </RutaPrivada>
                  }
                />                <Route
                  path="/procesoscomprasyventas"
                  element={
                    <RutaPrivada>
                      <ProcesosComprasYVentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesospercepcionesARBA"
                  element={
                    <RutaPrivada>
                      <ProcesosPercepcionesARBA />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesospercepcionesAGIP"
                  element={
                    <RutaPrivada>
                      <ProcesosPercepcionesAGIP />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesospagofacilpagomiscuentas"
                  element={
                    <RutaPrivada>
                      <ProcesosPagoFacilPagoMisCuentas />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/procesosdebitosautomaticos"
                  element={
                    <RutaPrivada>
                      <ProcesosDebitosAutomaticos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rendicionesdebitosautomaticos"
                  element={
                    <RutaPrivada>
                      <RendicionesDebitosAutomaticos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rendicionesmercadopago"
                  element={
                    <RutaPrivada>
                      <RendicionesMercadoPago />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/rendicionesbancos/:banco"
                  element={
                    <RutaPrivada>
                      <RendicionesBancos />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadosmensajes"
                  element={
                    <RutaPrivada>
                      <ListadosMensajes />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/listadostopesservicios"
                  element={
                    <RutaPrivada>
                      <ListadosTopesServicios />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/informesprocesosfacturacion"
                  element={
                    <RutaPrivada>
                      <InformesProcesosFacturacion />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/informesprocesospadrones"
                  element={
                    <RutaPrivada>
                      <InformesProcesosPadrones />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/qr"
                  element={
                    <RutaPrivada>
                      <Qr />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/qrcardio"
                  element={
                    <RutaPrivada>
                      <QrCardio />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/qremersur"
                  element={
                    <RutaPrivada>
                      <QrEmersur />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/estadisticacobradores"
                  element={
                    <RutaPrivada>
                      <EstadisticaCobradores />
                    </RutaPrivada>
                  }
                />
                <Route
                  path="/whatsapp"
                  element={
                    <RutaPrivada>
                      <WhatsAppCoexistence />
                    </RutaPrivada>
                  }
                />
              </Routes>
            </BrowserRouter>
          </ConfiguracionProvider>
        </ServiciosProvider>
      </AuthProvider>
    </AlertProvider>
  );
}

export default App;
